import { ReactComponent as AddToPlaylist } from 'assets/icons/icon-add-to-playlist.svg';

export default AddToPlaylist;
